import { ENGLISH_DATE as e } from "../english_date/index.js";
import { check_if_in_range as t } from "../../../utilities/index.js";
import { stitch_date as n } from "../../utilities/stitch_date.js";
import { split_date as r } from "../../utilities/split_date.js";
import { ad2bs as i } from "../../../calendar-carburettor/converter/index.js";
import { NEPALI_DATE as a } from "./index.js";
import o from "dayjs";
import { englishToNepaliNumber as s } from "nepali-number";
// src/design/forms/datepicker/calendar-engine/use-cases/nepali_date/get_day_info.ts
var c = i, l = ({ calendarReferenceDate: i, weekDayNum: l, weekNum: u, disable_date_after: d, disable_date_before: f, disabledWeekDays: p, holidays: m, date: h, weekSelectionEnabled: g, weekAnchorDate: _ }) => {
	let v = i.firstAdDayInBSMonth.getDay(), y = u * 7 + l - v, b = i.bsMonth, x = i.bsYear, S = !0;
	y <= 0 ? (y = a.previous_month_days(i) + y, S = !1, b = i.bsMonth === 1 ? 12 : i.bsMonth - 1) : y > i.numberOfDaysInBSMonth && (y -= i.numberOfDaysInBSMonth, S = !1, b = i.bsMonth === 12 ? 1 : i.bsMonth + 1);
	let C = r(c(o().format("YYYY-MM-DD"))), w = S ? C.day === y && C.month === i.bsMonth && C.year === i.bsYear : !1, T = e.get_eng_day_info(x, b, y), E = f || "", D = d || "", O = n({
		year: T.engYear,
		month: T.engMonth,
		day: T.engDay
	}), k = !1;
	g && _ ? k = o(O).isSame(o(_), "week") : h && (k = S ? h.bsDay === y && h.bsMonth === i.bsMonth && h.bsYear === i.bsYear : !1);
	let A = t(O, E, D), j = (p ?? []).includes(l) || (m ?? []).includes(O), M = !S || !A || j;
	return {
		workingDay: T.engDay,
		workingMonth: T.engMonth,
		workingYear: T.engYear,
		primaryDay: s(y),
		primaryMonth: s(b),
		primaryYear: s(x),
		secondaryDay: T.engDay,
		secondaryMonth: T.engMonth,
		secondaryYear: T.engYear,
		isCurrentMonth: S,
		isToday: w,
		isSelected: k,
		isDisabled: M,
		isDayOff: j
	};
};
export { l as get_day_info };

//# sourceMappingURL=get_day_info.js.map